// Countries a shop can be in, their dialling codes, and the towns a Rwandan
// shop picks from. Keep in step with backend-laravel/app/Support/Location.php.
export const COUNTRIES = [
  { name: "Rwanda", dial: "+250" },
  { name: "Kenya", dial: "+254" },
  { name: "Uganda", dial: "+256" },
  { name: "Tanzania", dial: "+255" },
  { name: "Burundi", dial: "+257" },
  { name: "South Sudan", dial: "+211" },
];

// Kigali plus the other 27 districts, each named after its main town.
export const RWANDA_CITIES = [
  "Kigali", "Bugesera", "Burera", "Gakenke", "Gatsibo", "Gicumbi", "Gisagara", "Huye", "Kamonyi",
  "Karongi", "Kayonza", "Kirehe", "Muhanga", "Musanze", "Ngoma", "Ngororero", "Nyabihu", "Nyagatare",
  "Nyamagabe", "Nyamasheke", "Nyanza", "Nyaruguru", "Rubavu", "Ruhango", "Rulindo", "Rusizi", "Rutsiro",
  "Rwamagana",
];

export const DEFAULT_COUNTRY = "Rwanda";

export const dialCodeFor = (country) => COUNTRIES.find((c) => c.name === country)?.dial || "+250";

// "+250" and "0788 123 456" → "+250788123456". A number already typed with
// a + is kept as it is.
export function joinPhone(dial, local) {
  const digits = String(local || "").replace(/[^\d+]/g, "");
  if (!digits) return "";
  if (digits.startsWith("+")) return digits;
  return dial + digits.replace(/^0+/, "");
}

// The other way round, for filling the field from a stored number.
export function splitPhone(phone, fallbackDial = "+250") {
  const value = String(phone || "");
  const match = COUNTRIES.map((c) => c.dial).find((dial) => value.startsWith(dial));
  return match ? { dial: match, local: value.slice(match.length) } : { dial: fallbackDial, local: value };
}
